import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopJoinableCoopListResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopJoinableCoopList = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.JoinableCoopList), switchMap(function (action) {
        var state = state$.value;
        var playerId = action.playerId ? action.playerId : selectOwnPlayerId(state);
        return deps
            .netSend({
            id: CommandCode.JoinableCoopList,
            props: {
                joinPolicy: action.joinPolicy,
                language: action.language,
                playerId: playerId,
            },
        })
            .pipe(map(actionCoopJoinableCoopListResponse), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopJoinableCoopList.ts
// module id = 1809
// module chunks = 3